<template>
  <div class="page__category category">
    <div class="breadcrumb__block">
      <router-link to="/">
        <p v-text="$store.getters.pages._.meta_title" />
      </router-link>
      <router-link :to="page.slug">
        <p class="breadcrumb__title" v-text="page.title" />
      </router-link>
      <p v-if="brandBreadcrumb" class="breadcrumb__title">{{ brandBreadcrumb }}</p>
    </div>
    <div>
      <h1 class="category__title">{{ $store.getters.page.title }}</h1>

      <template>
        <div class="intro__text is-ready category-text-block" style="text-align: center">
          <p v-if="this.page.description" v-html="this.page.description"/>
        </div>
      </template>
    </div>
    <div class="category__container container container--xl">
      <div class="category__triggers">
        <div
          class="category__trigger trigger"
          v-text="page.title"
          @click="beveragesOpen = true"
        />
        <div
          class="category__trigger trigger trigger--filter"
          v-text="ui.filter_label"
          @click="mobFilterOpen = true"
        />
      </div>
      <div class="category__filters" v-on-clickaway="closeFilters">
        <div class="category__filter filter" :class="{ 'is-open': beveragesOpen }">
          <div
            class="filter__trigger trigger"
            v-text="page.title"
            @click="
              openFilter = null;
              beveragesOpen = true;
            "
          />
          <div class="filter__list" v-if="beveragesOpen">
            <router-link
              class="filter__item"
              :to="item.path"
              v-for="(item, i) in $store.getters.nav.beverages"
              :key="'beverage' + i"
              v-text="item.title"
              v-if="item.path !== $route.path"
            />
          </div>
        </div>
        <div
          class="category__filter filter brand__filter"
          :class="{ 'is-open': openFilter === f }"
          v-if="page.filters"
          v-for="(filter, f) in page.filters"
          :key="f"
        >
          <div
            class="filter__trigger trigger"
            v-text="filterLabel(f)"
            @click="
              openFilter = f;
              beveragesOpen = false;
            "
          />
          <div class="filter__list" v-if="filter && openFilter === f">
            <div v-for="(item, i) in filter.values" :key="i">
              <router-link
                :to="$router.currentRoute.path + '/' + item.value"
                class="filter__item"
              >
                {{ item.label }}
              </router-link>
            </div>
            <div>
              <router-link :to="page.slug" class="filter__item">
                {{ filter["reset"] }}
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <transition-group
        :css="false"
        @enter="beverageEnter"
        name="beverages"
        tag="div"
        class="category__beverages"
      >
        <div
          class="category__beverage thumb"
          :data-index="index"
          v-for="(beverage, b, index) in filteredBeverages"
          :key="'beverage' + b"
          :style="{ backgroundColor: beverage.color }"
        >
          <!--<i class="thumb__image" :style="getDefaultImage(beverage)" />-->
          <router-link :to="beverage.path">
            <img
              v-if="beverage.sizes[0]"
              :src="getDefaultImage(beverage)"
              class="thumb__image"
              :alt="beverage.sizes[0].alt_title"
              :title="beverage.sizes[0].alt_title"
            />
            <img
              v-else
              :src="getDefaultImage(beverage)"
              class="thumb__image"
              :alt="$store.getters.page.title + ' ' + index"
              :title="$store.getters.page.title + ' ' + index"
            />
          </router-link>

          <div class="thumb__title">
            <router-link :to="beverage.path">
              {{ beverage.title }}
            </router-link>
            {{ beverage.type }}
          </div>
          <router-link :to="beverage.path" class="link" style="relative"
            ><span>{{$store.state.ui.read_more_label}} <i class="more__arrow more__category"></i></span
          ></router-link>
        </div>
      </transition-group>
      <div class="category__no-results" v-if="!hasBeverages">
        <h3 v-text="ui.no_results" />
      </div>
      <div class="container--l container related__text__columns brand__related">
        <div class="related_thumbs related__text related__text__products">
        <div>
          <p v-html="this.page.description_1"/>
        </div>
         <div>
          <p v-html="this.page.description_2"/>
        </div>
        </div>
      </div>
    </div>
    <transition name="modal">
      <div
        class="category__mobfilter mobfilter"
        ref="mobfilter"
        v-if="mobFilterOpen && device.winW < 769"
      >
        <div class="mobfilter__top">
          <i class="mobfilter__close" @click="mobFilterOpen = false" />
        </div>
        <div class="mobfilter__dialog">
          <div class="mobfilter__filters">
            <div
              class="mobfilter__group"
              :class="{ 'is-open': openFilter === f }"
              v-if="page.filters"
              v-for="(filter, f) in page.filters"
              :key="f"
            >
              <div class="mobfilter__label" v-text="page.filters[f]['label']" />

              <ul class="mobfilter__list">
                <li
                  class="mobfilter__item"
                  v-for="(item, i) in filter.values"
                  :key="i"
                  :class="{ 'is-active': activeFilters[f] === i }"
                >
                  <router-link :to="$router.currentRoute.path + '/' + item.value">
                    <i class="mobfilter__check" />
                    <span class="mobfilter__text" v-text="item.label" />
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <transition name="modal">
      <div
        class="category__dropdown dropdown"
        ref="dropdown"
        v-if="beveragesOpen && device.winW < 769"
      >
        <div class="dropdown__top">
          <i class="dropdown__close" @click="beveragesOpen = false" />
        </div>
        <div class="dropdown__dialog">
          <ul class="dropdown__list">
            <router-link
              class="dropdown__item"
              tag="li"
              :to="item.path"
              v-for="(item, i) in $store.getters.nav.beverages"
              :key="'beverage' + i"
              v-if="item.path !== $route.path"
             
            >
              <i class="dropdown__check" />
              <a class="dropdown__text" v-text="item.title" />
            </router-link>
          </ul>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import anime from 'animejs'
// import latinize from 'latinize'

import { mapGetters } from 'vuex'
import page from '@/mixins/page'
import { mixin as clickaway } from 'vue-clickaway'

import ifDefined from '@/tools/ifDefined'

import SearchIcon from '@/elements/SearchIcon'

export default {
  mixins: [page, clickaway],
  components: { SearchIcon },
  computed: {
    ...mapGetters(['ui', 'device', 'lang'])
  },
  data() {
    return {
      beveragesOpen: false,
      openFilter: null,
      mobFilterOpen: false,
      beverages: {},
      activeFilters: {},
      filteredBeverages: {},
      hasBeverages: true,
      brandBreadcrumb: null
      // searchInput: ''
    }
  },
  name: 'BeverageCategory',
  methods: {
    getDefaultImage(beverage) {
      var o = {}
      if (beverage.sizes) {
        beverage.sizes.forEach((b, i) => {
          if (Number(b.show_default) === 1) {
            // o = this.bg(b['size_image_' + this.lang])
            o = this.mediaPath(b['size_image_' + this.lang])
          }
        })
      }
      return o
    },
    beverageEnter(el, done) {
      anime({
        targets: el,
        opacity: [0, 1],
        translateY: ['3rem', 0],
        duration: 350,
        easing: 'easeOutQuad',
        elasticity: 0,
        delay: Number(el.dataset.index * 150),
        complete: () => {
          done()
        }
      })
    },
    openBeverages() {
      this.beveragesOpen = true
      this.openFilter = null
    },
    closeFilters() {
      if (this.device.winW > 768) {
        this.openFilter = null
        this.beveragesOpen = false
      }
    },
    filterLabel(f) {
      var label = this.page.filters[f]['label']

      if (ifDefined(this.activeFilters[f])) {
        Object.keys(this.page.filters[f]['values']).forEach((filterVal) => {
          var filter = this.page.filters[f]['values'][filterVal]
          if (filter['value'] === this.activeFilters[f]) {
            label = filter['label']
            this.brandBreadcrumb = label
          }
        })
      }
      return label
    },
    setFilter(filter, value) {
      var filtered = {}
      if (value !== null) {
        this.activeFilters[filter] = value
      } else {
        delete this.activeFilters[filter]
      }
      Object.keys(this.beverages).forEach((beverage) => {
        var match = true
        Object.keys(this.filters).forEach((filter) => {
          if (
            this.beverages[beverage]['filters'][filter] !== this.activeFilters[filter]
          ) {
            match = false
          }
        })
        if (match) {
          filtered[beverage] = this.beverages[beverage]
        }
      })
      this.openFilter = null
      this.mobFilterOpen = false
      this.filteredBeverages = filtered
    },
    checkFilters() {
      this.beverages = this.page.beverages
      if (Object.keys(this.$route.query).length) {
        this.filters = this.$route.query
        Object.keys(this.$route.query).forEach((filter) => {
          this.setFilter(filter, this.$route.query[filter].replace('/', ''))
        })
        this.brandBreadcrumb = this.$route.query.brand
      } else {
        var shownBeverages = {}
        Object.keys(this.beverages).forEach((b) => {
          if (this.beverages[b].deleted === 0) {
            shownBeverages[b] = this.beverages[b]
          }
        })
        this.filteredBeverages = shownBeverages
        this.brandBreadcrumb = null
      }
    }
  },
  mounted() {
    this.checkFilters()
    this.brandBreadcrumb = this.$route.query.brand
      ? this.$route.query.brand.toUpperCase()
      : null
  },
  watch: {
    $route(to, from) {
      this.checkFilters()
      this.openFilter = null
      this.beveragesOpen = false
      if (to.path !== from.path) {
        this.activeFilters = {}
      }
    },
    mobFilterOpen(newVal, oldVal) {
      if (newVal && this.device.winW < 769) {
        this.$nextTick(() => {
          var $page = document.querySelector('[data-page]')
          this.$refs['mobfilter'].style.top = $page.scrollTop + 'px'
          $page.style.zIndex = 5
          this.$store.dispatch('scrollFix')
        })
      } else {
        this.$store.dispatch('scrollUnFix')
      }
    },
    beveragesOpen(newVal, oldVal) {
      if (newVal && this.device.winW < 769) {
        this.$nextTick(() => {
          var $page = document.querySelector('[data-page]')
          this.$refs['dropdown'].style.top = $page.scrollTop + 'px'
          $page.style.zIndex = 5
          this.$store.dispatch('scrollFix')
        })
      } else {
        this.$store.dispatch('scrollUnFix')
      }
    },
    filteredBeverages(newVal, oldVal) {
      setTimeout(() => {
        this.hasBeverages = Object.keys(newVal).length
      }, 3)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/templates/BeverageCategory.vue